export function inferConnectToolkitSlugFromTitle(title) {
  const t = String(title || '').toLowerCase()
  if (t.includes('gmail') || t.includes('google mail')) return 'gmail'
  if (t.includes('outlook') || t.includes('microsoft 365') || t.includes('exchange')) return 'outlook'
  if (t.includes('stripe')) return 'stripe'
  if (t.includes('hubspot')) return 'hubspot'
  if (t.includes('datadog')) return 'datadog'
  return null
}

export function toolkitConnectionRowId(toolkitSlug) {
  return `toolkit-${String(toolkitSlug || '').toLowerCase().trim()}`
}
